import React from 'react';

const Footer = () => {
  return (
    <footer className="fixed bottom-0 left-0 w-full flex flex-wrap items-center justify-between bg-black px-6 py-1 z-20">
      {/* Left Section */}
      <div className="flex-grow flex flex-wrap items-center justify-start space-x-2 text-sm">
        <a href="https://grift.wtf">
          <img 
            src={`${process.env.PUBLIC_URL}/images/ggg--max-pain.gif`} 
            alt="Home" 
            className="w-10 h-10" 
          />
        </a>
        <span className="text-gray-400">|</span>
        <a
          href="https://xcopy.art/works/banksta"
          className="font-bold text-[#632af8] hover:text-[#00f6ff] transition-colors"
        >
          BANKSTA
        </a>
      </div>
      {/* Right Section */}
      <div className="flex-shrink-0 flex items-center space-x-4">
        <a href="https://x.com/0xConcept">
          <img 
            src={`${process.env.PUBLIC_URL}/images/logo--x-white.png`} 
            alt="Icon 1" 
            className="w-6 h-6" 
          />
        </a>
        <a href="https://warpcast.com/concept">
          <img 
            src={`${process.env.PUBLIC_URL}/images/logo--warpcast.png`} 
            alt="Icon 2" 
            className="w-6 h-6" 
          />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
